import { render } from "./NewAlert.vue?vue&type=template&id=c67463c0&scoped=true"
import script from "./NewAlert.vue?vue&type=script&lang=js"
export * from "./NewAlert.vue?vue&type=script&lang=js"

import "./NewAlert.vue?vue&type=style&index=0&id=c67463c0&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c67463c0"]])

export default __exports__
import QCardSection from 'quasar/src/components/card/QCardSection.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCardSection});qInstall(script, 'directives', {ClosePopup});
